import { FaLock, FaLockOpen, FaQuestionCircle } from "react-icons/fa";

export const cashStatusConfig = {
    0: {
      id: 0,
      text: "Estado Desconocido",
      textSecondary: "Sin información",
      icon: <FaQuestionCircle />,
      color: "#bdbdbd", // Gris
    },
    1: {
      id: 1,
      text: "Caja Abierta",
      textSecondary: "Saldo al cierre",
      icon: <FaLockOpen />,
      color: "#1caf21", // Verde
    },
    2: {
      id: 2,
      text: "Caja Cerrada",
      textSecondary: "Saldo apertura",
      icon: <FaLock />,
      color: "#e92b2b", // Rojo
    },
};